import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as fromConfiguration from '@appStore/configuration';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  constructor(public translate: TranslateService, private configStore: Store<fromConfiguration.State>,private router: Router
    ) { }

  ngOnInit() {
    //Första gången man hamnar på felsidan försök ladda om och reparera automatiskt.
    this.subs.sink = this.configStore.select(fromConfiguration.getErrorRefreshPerformed).subscribe((errorRefreshPerformed:number) =>{
      if(errorRefreshPerformed === 0 ){
        this.configStore.dispatch(new fromConfiguration.ErrorRefreshPerformed());
        this.router.navigate(['/'])
      }
    });    
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
